import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { ReferenceBook } from '@/features/referenceBooks/types';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

/** Job position/title picker for the connection-application form's contact person — see
 * ConnectionApplicationEntity.ContactPersonPositionId. Read-only proxy onto the platform-wide
 * reference book. */
export const contactPersonPositionsApi = createApi({
  reducerPath: 'contactPersonPositionsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: Config.VITE_API_URL + '/contact-person-positions',
  }),
  endpoints: builder => ({
    getContactPersonPositions: builder.query<ReferenceBook[], void>({
      query: () => ({ url: '' }),
    }),
  }),
});

export const { useGetContactPersonPositionsQuery } = contactPersonPositionsApi;
